import "./Footer.scss"

function Footer() {
    return (
        <footer>
            <p className='container'>© {new Date().getFullYear()} adidas America, Inc.</p>
        </footer>
    )
}

export default Footer
